export default __webpack_public_path__ + "static/media/207858.5cecb265.jpg";